import { createContext, useEffect, useState } from 'react';

import { client, getAuthTokenFromCookie, removeAuthTokenFromCookie } from '@/shared/lib/client';

type User = {
  userId: string;
  username: string;
  displayName: string;
  email: string;
  avatar: string;
};

export const UserContext = createContext<{
  user: User | null;
  setUser: (user: User | null) => void;
  hasToken: boolean;
  isLoading: boolean;
}>({
  user: null,
  setUser: () => {},
  hasToken: false,
  isLoading: false,
});

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [hasToken, setHasToken] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const token = getAuthTokenFromCookie();
    setHasToken(!!token);

    if (!token) {
      return;
    }

    setIsLoading(true);
    client
      .get('/api/user/me')
      .then((res) => {
        setUser(res.data);
      })
      .catch((error) => {
        console.error('Failed to fetch user info:', error);
        // 如果获取用户信息失败，清除 token 和相关状态
        setHasToken(false);
        setUser(null);
        // 可选：清除无效的 token cookie
        removeAuthTokenFromCookie();
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, hasToken, isLoading }}>
      {children}
    </UserContext.Provider>
  );
};
